import { Box } from '@factorialco/deprecated-design-system'

import BulkDeleteDocuments from 'modules/documents/components/BulkDeleteDocuments'
import BulkAssigner from 'modules/documents/components/BulkFiles/DocumentAssigner/BulkAssigner'
import Counter from 'modules/documents/components/BulkFiles/DocumentAssigner/Header/Counter'
import LeftChevron from 'modules/documents/components/BulkFiles/DocumentAssigner/Header/LeftChevron'
import RightChevron from 'modules/documents/components/BulkFiles/DocumentAssigner/Header/RightChevron'
import Tags from 'modules/documents/components/BulkFiles/DocumentAssigner/Header/Tags'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'
import { isPersonalFilesWorkflow } from 'modules/documents/lib/distributionWorkflows'

interface Props {
  document: Document
  documents: Document[]
  uploadProcess: UploadProcess
  index: number
  onClickBack: () => void
  onClickForward: () => void
  onRefresh: () => void
}

const AssignerHeader = ({
  documents,
  document,
  uploadProcess,
  onClickBack,
  onClickForward,
  index,
  onRefresh,
}: Props) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      paddingY="s12"
      paddingX="s16"
      justifyContent="spaceBetween"
      border={{
        bottom: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Box flexDirection="row" gap="s8">
        <LeftChevron documents={documents} onClick={onClickBack} />
        <Counter documents={documents} index={index} />
        <RightChevron documents={documents} onClick={onClickForward} />
        <Tags uploadProcess={uploadProcess} />
      </Box>
      <Box flexDirection="row">
        {isPersonalFilesWorkflow(uploadProcess) && (
          <BulkAssigner
            uploadProcess={uploadProcess}
            onFinished={onRefresh}
            documents={documents}
          />
        )}
        <Box paddingLeft="s8">
          <BulkDeleteDocuments
            document={document}
            documents={documents}
            onDelete={onRefresh}
            attachment="top center"
            icon={'ellipsis'}
            type="secondary"
          />
        </Box>
      </Box>
    </Box>
  )
}

export default AssignerHeader
